<div class="footer-wrap">
  <div class="content">
    <div class="section-1">
      @if (!vars.isMobile()) {
        <ng-container *ngTemplateOutlet="supportDetails"></ng-container>
      }
      @if (!vars.isMobile()) {
        <div class="logo">
          <div class="social-icons">
            <div class="imgHolder"><img class="brand-logo" ngSrc="{{vars.domainData().logoDarkBg}}" width="175" height="72" [alt]="vars.domainData().name" priority /></div>
            <div class="icons-container">
              <div class="img-container">
                @for (item of socialhandlers; track item) {
                  <img (click)="linkhandler(item.clickUrl || '')" [ngSrc]="item.logopath" [width]="16" [height]="16">
                }
              </div>
              <span class="followers">Be part of the movement. Follow {{vars.domainData().name}}.</span>
            </div>
          </div>
        </div>
      }
      @if (vars.isMobile()) {
        <div class="support-details">
          <div class="imgHolder"><img class="brand-logo" ngSrc="{{vars.domainData().logoDarkBg}}" width="175" height="72" [alt]="vars.domainData().name" priority /></div>
        </div>
      }
      @if (vars.isMobile()) {
        <div class="logo">
          <div class="social-icons">
            <div class="img-container">
              @for (item of socialhandlers; track item) {
                <img (click)="linkhandler(item.clickUrl || '')" [ngSrc]="item.logopath" [width]="16" [height]="16" [alt]="item?.clickUrl || 'share'">
              }
            </div>
            <span class="followers">Be part of the movement. Follow {{vars.domainData().name}}.</span>
          </div>
        </div>
      }
    </div>
    <div class="section-2">
      @if (vars.isMobile()) {
        <ng-container *ngTemplateOutlet="supportDetails"></ng-container>
      }
      <div class="policies">
        <div class="terms-policy">
          <span><a style="text-decoration: none;"
              href="https://app.termageddon.com/api/policy/VmtOVlMwbFFhRWd6VTFKM2VtYzlQUT09?h-align=left&table-style=accordion"
              target="_blank">Terms of Service</a></span>
          <span><a style="text-decoration: none;"
              href="https://app.termageddon.com/api/policy/VVZWTE0zUm1UWEZyUkdkelluYzlQUT09?h-align=left&table-style=accordion"
              target="_blank">Privacy Policy</a></span>
          <span routerLink="/aboutus">About Us</span>
          <span><a style="text-decoration: none;" href="https://www.equalall.org/blog" target="_blank">Blog</a></span>
        </div>
        <div class="terms-policy">
          <span><a style="text-decoration: none;" rel="nofollow"
              href="https://app.termageddon.com/api/policy/UlZaM1MwTlpWWEYzTkZKb1MxRTlQUT09?css-compatibility=true&h-align=left&table-style=accordion"
              target="_blank">Use of Cookies</a></span>
          <span routerLink="/donorprotectionpolicy">{{vars.domainData().name}} Donor Protection Policy</span>
          <!-- <span routerLink="/success-stories">Our Impact</span> -->
        </div>
        <div class="terms-policy">
          <span><a style="text-decoration: none;"
              href="{{campaignUrl()}}"
              target="_blank">Donate Now</a></span>
        </div>
      </div>
      <div class="payment-terms">
        <img class="payment-logo" src="assets/images/footer/paypalstripe.svg" alt="visa mastercard logo" />
        <div class="secure"><img class="secure-logo" src="assets/images/lock.png"
            alt="visa mastercard logo" /><span>100% Secure</span></div>
      </div>
    </div>
    <div class="section-3">
      <div class="main-data">
        <div class="copyright">Copyright © {{currentYear}} {{vars.domainData().name}}. All Rights Reserved.</div>
        <div class="disclaimer">
          {{vars.domainData().name}} ({{vars.defaultOrganiserName}}) is a California-registered 501(c)(3) nonprofit
          organization (EIN
          93-3691588).
        </div>
      </div>
      <!-- <div class="brand-images">
        @for (img of brandImages; track img) {
          <img class="brand-image" [alt]="img?.brandName" [src]="img?.whitelogo">
        }
      </div> -->
    </div>
  </div>
</div>

<ng-template #supportDetails>
  <div class="support-details">
    <div class="title">For any queries</div>
    <div class="email">Email: <a style="cursor: pointer;" href="mailto:support@equalall.org">support&#64;equalall.org</a></div>
    <div class="phone">Contact No: +1 3322698250</div>
    <div class="address">Address: 9984 Scripps Ranch Blvd, Unit #804 San Diego, CA 92131</div>
  </div>
</ng-template>